<template>
  <section class="btn_main_wrap">
    <p class="btn-title">
      {{ title }}
      <a v-if="lightBoxCopy.title" class="info-button_popin" @click="togglePopin">
        <svg class="icon-info_small">
          <use xlink:href="#icon-Info_small" />
        </svg>
      </a>
    </p>
    <ul class="btn-quantity btn_wrap" data-tracking-id="specification-speed">
      <li  data-tracking-label="less" v-longclick="() => updateQty()" @click="updateQty()">
        <a class="btn" >
          <ul>
            <li></li>
          </ul>
        </a>
      </li>
      <li>
        <a class="btn" >
          <template v-if="SoM == null">
             <span>{{SoM2}} &nbsp;</span><input  class="test-scale" v-model="value" @keydown="filterKey" ></template>
          <template  v-else>  <input v-model="value" class="test-scale" @keydown="filterKey"> <span>&nbsp;{{SoM}}</span></template>
        </a>
      </li>
      <li  data-tracking-label="more" v-longclick="() => updateQty(true)" @click="updateQty(true)">
        <a class="btn" >
          <ul>
            <li></li>
            <li></li>
          </ul>
        </a>
      </li>
    </ul>
    <lightbox :visible="lightboxVisible" v-on:close="lightboxVisible = false">
      <div class="lightbox-simple-content">
        <ul>
          <li>
            <span v-html="lightBoxCopy.title" />
            <p v-html="lightBoxCopy.subtitle" />
          </li>
        </ul>
      </div>
    </lightbox>
  </section>
</template>
<script>
import { mapState } from "vuex";
import Lightbox from "@/components/shared/LightBox";
export default {
  props: {
    SoM: String,
    SoM2: String,
    title: String,
    active: [String, Number],
    lightBoxCopy: Object,
    range: Object,
    step: [String, Number],
    defaultValue: [String, Number]
  },
  data() {
    return {
    
      inputValue: 0,
      lightboxVisible: false,
      value: parseFloat(this.defaultValue),
      interval:false,
    };
  },
  components: {
    Lightbox
  },
  watch: {
    active: function(val) { 
      this.value = parseFloat(val)
    },
    inputValue(val) {
      if (Number.isNaN(val)) {
        this.inputValue = 0
      }
      if(val < this.range.min) {
        this.inputValue = this.range.min
      }
      if(val > this.range.max) {
        this.inputValue = this.range.max
      }
      this.$emit('input', val)
      this.value = this.inputValue
    },
    value(val) {
      if (Number.isNaN(val)) {
        this.inputValue = 0
      }
      if(val < this.range.min) {
        this.inputValue = this.range.min
      }
      if(val > this.range.max) {
        this.inputValue = this.range.max
      }
      this.inputValue = parseFloat(val)
      this.$emit("event_qty",this.inputValue )
    },
  },

  
  methods: {
    togglePopin() {
      this.lightboxVisible = !this.lightboxVisible;
    },
    updateQty(bool) {
      const min = this.range.min
      const max = this.range.max
      if(bool) {
        if(this.value >= max) return
        this.value = Math.round((this.value + this.step) *100) / 100
      }
      else {
        if(this.value <= min) return 
        this.value = Math.round((this.value - this.step) *100) / 100    
      }
      return this.$emit(
        "event_qty",
        this.value 
      );
    },
    filterKey(evt) {
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ',', 'Backspace', 'ArrowLeft', 'ArrowRight'];
      const keyPressed = evt.key;
      if (!keysAllowed.includes(keyPressed)) {
          evt.preventDefault()
      }
    }
  }
};
</script>
